import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import './Hero.css'; // zorg dat dit pad klopt

export default function TestimonialCard({ text, style }) {
  return (
    <div
      /* ↓  haal position-absolute weg ↓ */
      className="testimonial-card p-4 shadow-sm"
      style={style}                /* top/left worden op mobile genegeerd */
    >
      <div className="d-flex mb-2">
        {[...Array(5)].map((_, idx) => (
          <FontAwesomeIcon
            key={idx}
            icon={faStar}
            className="text-warning me-1"
          />
        ))}
      </div>
      <p className="mb-0">&quot;{text}&quot;</p>
    </div>
  );
}
